import React from "react";
import "../../../css/ViewQavachStaffModal.css";


interface QavachUser {
  _id: string;
  email: string;
  displayName: string;
  roleType: string;
  status: string;
  role: string;
  createdAt: string;
  disabledAt?: string | null;
}

interface ViewQavachStaffModalProps {
  user: QavachUser;
  onClose: () => void;
  onEdit: () => void;
  onDisable: () => void;
}

const ViewQavachStaffModal: React.FC<ViewQavachStaffModalProps> = ({
  user,
  onClose,
  onEdit,
  onDisable,
}) => {
  return (
    <div className="view-qavach-staff-modal-overlay" onClick={onClose}>
      <div className="view-qavach-staff-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="view-qavach-staff-modal-header">
          <h2>View Qavach Staff Role</h2>
          <button className="view-qavach-staff-close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="view-qavach-staff-modal-body">
          <div className="view-qavach-staff-field-group">
            <label>User ID</label>
            <p className="view-qavach-staff-field-value">{user.email}</p>
          </div>

          <div className="view-qavach-staff-field-group">
            <label>User Name</label>
            <p className="view-qavach-staff-field-value">{user.displayName}</p>
          </div>

          <div className="view-qavach-staff-field-group">
            <label>Role</label>
            <p className="view-qavach-staff-field-value">{user.role}</p>
          </div>

          <div className="view-qavach-staff-field-group">
            <label>Status</label>
            <p className="view-qavach-staff-field-value">{user.status}</p>
          </div>

          {/* <div className="field-group">
            <label>Created On</label>
            <p className="field-value">
              {new Date(user.createdAt).toLocaleDateString()}
            </p>
          </div>

          <div className="field-group">
            <label>Disabled On</label>
            <p className="field-value">
              {user.disabledOn
                ? new Date(user.disabledOn).toLocaleDateString()
                : "-"}
            </p>
          </div> */}

          <div className="view-qavach-staff-field-group">
            <label>Created On</label>
            <p className="view-qavach-staff-field-value">
              {user.createdAt && user.createdAt !== "-"
                ? new Date(user.createdAt).toLocaleDateString()
                : "-"}
            </p>
          </div>

          <div className="view-qavach-staff-field-group">
            <label>Disabled On</label>
            <p className="view-qavach-staff-field-value">
              {user.disabledAt
                ? new Date(user.disabledAt).toLocaleDateString()
                : "-"}
            </p>
          </div>

          <div className="view-qavach-staff-field-group">
            <label>Additional Information</label>
            <textarea
              className="view-qavach-staff-additional-info"
              placeholder="Add any additional notes here..."
              rows={4}
            />
          </div>
        </div>

        <div className="view-qavach-staff-modal-footer">
          <button className="view-qavach-staff-btn btn-close" onClick={onClose}>
            Close
          </button>
          <button className="view-qavach-staff-btn btn-edit" onClick={onEdit}>
            Edit
          </button>
          {/* <button className="btn btn-disable" onClick={onDisable}>
            Disable
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default ViewQavachStaffModal;